import { GridContext } from '../Context';
import { ColumnContainer } from '../styled';
export function Column(props) {
    const { children, width = '100%', className } = props;
    return (<GridContext.Consumer>
      {({ spacing, horizontal, vertical }) => (<ColumnContainer className={className} $spacing={spacing} $horizontal={horizontal} $vertical={vertical} style={{ width }}>
          {children}
        </ColumnContainer>)}
    </GridContext.Consumer>);
}
